import { Component } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
@TraceClassDecorator()
export class AppComponent { }
